import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { LetteraDiffida } from '../../../models/lettera-diffida';
import { SezioneLettereDiffidaFull } from '../../../models/sezioni/sezione-lettere-diffida-full';
import { LettereDiffidaDatiGeneraliComponent } from './lettere-diffida-dati-generali.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [lettere-diffida-dati-generali-update]',
  templateUrl: 'lettere-diffida-dati-generali-update-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LettereDiffidaDatiGeneraliUpdateMod {
  @Output() onReturn: EventEmitter<SezioneLettereDiffidaFull> = new EventEmitter<SezioneLettereDiffidaFull>();
  @ViewChild('formDatiGenerali') formDatiGenerali: LettereDiffidaDatiGeneraliComponent;

  inizializza(urlUpdateAssociativa: string, letteraDiffida: LetteraDiffida, idSezione: string, urlReadSezioneControparti: string, idSezioneControparti: string) {
    this.formDatiGenerali.inizializza(urlUpdateAssociativa, letteraDiffida, idSezione, urlReadSezioneControparti, idSezioneControparti);
    openModal('modalmoddatigenerali');
  }

  createForm() {
    this.formDatiGenerali.createForm();
  }

  manageModal(sezione: SezioneLettereDiffidaFull) {
      closeModal('modalmoddatigenerali');
      this.onReturn.emit(sezione);
  }
}
